import React, { createContext, useContext, useState, useRef, useEffect, useCallback } from 'react';

// Audio data - 91 intrari reale, cate una pentru fiecare harta din Galerie,
// in ACEEASI ORDINE ca in Galerie:
// secțiunile Dobrogea, Dacia, Valahia/Moldova/Transilvania, Imperiul Otoman,
// Europa, Lumea Antică, Asia, iar in fiecare secțiune crescator pe an
// (backendul sorteaza cu .sort("year", 1) in /api/maps/all-lightweight).
// Episoadele sunt numerotate 1-91 in aceasta ordine.
// Nu lipseste niciun rezumat: 91 de harti, 91 de episoade.
export const audioData = [
  // ===== DOBROGEA =====
  {
    id: 1,
    title: "Explication des General Weissmanns Attaque",
    subtitle: "Atacul Generalului Weissmann la Tulcea și Babadag",
    audioUrl: "/audio/Explication des General Weissmanns Attaque.mp3",
    duration: "5:00",
    episode: 1,
    date: "Februarie 2026",
    image: "/maps/Z8L_5035_thumb.jpg"
  },
  {
    id: 2,
    title: "DES KOENIGREICHS BULGARIEN Oestliche Hælffe",
    subtitle: "Jumătatea Estică a Regatului Bulgariei Nr. 14",
    audioUrl: "/audio/DES KOENIGREICHS BULGARIEN Oestliche Hælffe.mp3",
    duration: "5:00",
    episode: 2,
    date: "Februarie 2026",
    image: "/maps/Z8L_5028.jpg"
  },
  {
    id: 3,
    title: "Delta Dunării - Direcțiunea Pescăriilor",
    subtitle: "Dr. Grigore Antipa (1900-1916)",
    audioUrl: "/audio/DELTA DUNARII ANTIPA.mp3",
    duration: "5:10",
    episode: 3,
    date: "Februarie 2026",
    image: "/maps/Z8W_9209_thumb.jpg"
  },
  {
    id: 4,
    title: "Harta Teritoriilor Anexate (1913)",
    subtitle: "Turtucaia, Silistra, Dobrici, Balcic",
    audioUrl: "/audio/harta-cadrilaterului-1913.mp3",
    duration: "4:45",
    episode: 4,
    date: "Februarie 2026",
    image: "/maps/NZ8_8933_thumb.jpg"
  },
  {
    id: 5,
    title: "Județul Tulcea după noua împărțire administrativă",
    subtitle: "Dobrogea de Nord - Județul Tulcea, 1928",
    audioUrl: "/audio/Județul Tulcea.mp3",
    duration: "5:00",
    episode: 5,
    date: "Iunie 2026",
    image: "/maps/JD_TULCEA_1928.jpg"
  },
  {
    id: 6,
    title: "Județul Caliacra după noua împărțire administrativă",
    subtitle: "Cadrilaterul / Dobrogea de Sud - Județul Caliacra, 1938",
    audioUrl: "/audio/Județul Caliacra.mp3",
    duration: "5:00",
    episode: 6,
    date: "Iunie 2026",
    image: "/maps/JD_CALIACRA_1938.jpg"
  },
  {
    id: 7,
    title: "Județul Constanța după noua împărțire administrativă",
    subtitle: "Dobrogea interbelică - Județul Constanța, 1938",
    audioUrl: "/audio/Județul Constanța.mp3",
    duration: "5:00",
    episode: 7,
    date: "Iunie 2026",
    image: "/maps/JD_CONSTANTA_1938.jpg"
  },
  {
    id: 8,
    title: "Județul Durostor după noua împărțire administrativă",
    subtitle: "Cadrilaterul / Dobrogea de Sud - Județul Durostor, 1938",
    audioUrl: "/audio/Județul Durostor.mp3",
    duration: "5:00",
    episode: 8,
    date: "Iunie 2026",
    image: "/maps/JD_DUROSTOR_1938.jpg"
  },

  // ===== DACIA =====
  {
    id: 9,
    title: "TABVLA EVROPAE IX",
    subtitle: "A noua hartă a Europei - Ptolemeu/Münster",
    audioUrl: "/audio/TABVLA EVROPAE IX.mp3",
    duration: "5:00",
    episode: 9,
    date: "Februarie 2026",
    image: "/maps/Z8L_5030.jpg"
  },
  {
    id: 10,
    title: "Tabula Nova Europae Orientalis et Meridionalis",
    subtitle: "Spațiul Daco-Moesic în Antichitate - Waldseemüller, 1525",
    audioUrl: "/audio/daciarum-moesiarumque-ortelius.mp3",
    duration: "3:00",
    episode: 10,
    date: "Aprilie 2026",
    image: "/maps/daciarum-moesiarumque-ortelius.jpeg"
  },
  {
    id: 11,
    title: "Tab. VIII Europae — Sarmatia, Maeotis, Dacia",
    subtitle: "Sarmatia, Dacia și Maeotis — Gerardus Mercator după Ptolemeu, 1578/1695",
    audioUrl: "/audio/mercator-sarmatia-1578.mp3",
    duration: "25:35",
    episode: 11,
    date: "Mai 2026",
    image: "/maps/117951.jpg"
  },
  {
    id: 12,
    title: "Daciarum, Moesiarumque, Vetus Descriptio",
    subtitle: "Dacia și Moesia în Antichitate — Abraham Ortelius, Parergon, ediția 1595",
    audioUrl: "/audio/Daciarum Moesiarumque Vetus Descriptio - Ortelius 1595.mp3",
    duration: "16:24",
    episode: 12,
    date: "Noiembrie 2026",
    image: "/maps/ORTELIUS_DACIARUM_PARERGON_1595_thumb.jpg"
  },
  {
    id: 13,
    title: "Tabula Europae IX",
    subtitle: "Geographia Universalis - Giovanni Antonio Magini, 1596",
    audioUrl: "/assets/audio/Tabula Europae IX.mp3",
    duration: "5:00",
    episode: 13,
    date: "Februarie 2026",
    image: "/maps/NZ8_8871_thumb.jpg"
  },
  {
    id: 14,
    title: "Daciarum, Moesiarumque, Vetus Descriptio",
    subtitle: "Dacia și Moesia în Antichitate - Abraham Ortelius 1603",
    audioUrl: "/audio/Abraham Ortelius 1603 Daciarum, Moesiarumque, Vetus Descriptio AUDIO.mp3",
    duration: "5:00",
    episode: 14,
    date: "Aprilie 2026",
    image: "/maps/daciarum-moesiarumque-vetus.jpg"
  },
  {
    id: 15,
    title: "Illyricum Orientis",
    subtitle: "Regiones Danubianae - Sanson & De Rossi",
    audioUrl: "/audio/ILIRICUM ORIENTIS.mp3",
    duration: "7:47",
    episode: 15,
    date: "Februarie 2026",
    image: "/maps/NZ8_8924.jpg"
  },
  {
    id: 16,
    title: "Regiones Danubianae",
    subtitle: "Călătorie în Timpul Imperiilor - Weigel",
    audioUrl: "/audio/Regiones Danubianae.mp3",
    duration: "5:00",
    episode: 16,
    date: "Februarie 2026",
    image: "/maps/NZ8_8910.jpg"
  },
  {
    id: 17,
    title: "Tab. IX. Europae Continens Daciam, Misiam, Thraciam ac Macedoniae partem",
    subtitle: "Spațiul Traco-Dacic și Peisajul Senzorial Antic - Mercator 1578/1730",
    audioUrl: "/audio/Tab. IX. Europae Continens Daciam, Misiam, Thraciam ac Macedoniae partem AUDIO.mp3",
    duration: "5:00",
    episode: 17,
    date: "Aprilie 2026",
    image: "/maps/tab-ix-europae-continens-daciam.jpg"
  },

  // ===== VALAHIA / MOLDOVA / TRANSILVANIA =====
  {
    id: 18,
    title: "2 Transsylvania XXI Nova Tabula",
    subtitle: "Cosmographia - Sebastian Münster",
    audioUrl: "/assets/audio/Transsylvania XXI Nova Tabula (Ed. II).mp3",
    duration: "5:00",
    episode: 18,
    date: "Februarie 2026",
    image: "/maps/NZ8_8906.jpg"
  },
  {
    id: 19,
    title: "Von Transsylvania, Siebenbürgen",
    subtitle: "Cosmographia - Sebastian Münster",
    audioUrl: "/audio/Von Transsylvania, Siebenbürgen.mp3",
    duration: "4:30",
    episode: 19,
    date: "Februarie 2026",
    image: "/maps/munster_cosmographia_1550_thumb.jpg"
  },
  {
    id: 20,
    title: "Die Siebenbürg, so man sunst auch Transsylvaniam nent",
    subtitle: "Transilvania în Cosmographia lui Sebastian Münster, după modelul lui Johannes Honterus",
    audioUrl: "/audio/Die Siebenburg - Transsylvania Munster.mp3",
    duration: "13:04",
    episode: 20,
    date: "August 2026",
    image: "/maps/MUNSTER_SIEBENBURGEN_1550.jpg"
  },
  {
    id: 21,
    title: "Transsylvania XXI Nova Tabula",
    subtitle: "Gravură pe cupru - Johannes Sambucus",
    audioUrl: "/assets/audio/Transsylvania XXI Nova Tabula.mp3",
    duration: "5:00",
    episode: 21,
    date: "Februarie 2026",
    image: "/maps/NZ8_8927_thumb.jpg"
  },
  {
    id: 22,
    title: "VALACHIA, SERVIA, BULGARIA, VND ROMANIA",
    subtitle: "Valahia, Serbia, Bulgaria și Rumelia",
    audioUrl: "/audio/Valachia, Servia, Bulgaria, Romania.mp3",
    duration: "6:04",
    episode: 22,
    date: "Februarie 2026",
    image: "/maps/Z8L_5079.jpg"
  },
  {
    id: 23,
    title: "Transylvania Siebenbürgen",
    subtitle: "Transilvania în Atlasul Cosmographicae al lui Mercator - Gerardus Mercator, 1595",
    audioUrl: "/audio/Transylvania Siebenburgen 1595.mp3",
    duration: "5:00",
    episode: 23,
    date: "Iunie 2026",
    image: "/maps/MERCATOR_TRANSYLVANIA_1595.jpg"
  },
  {
    id: 24,
    title: "Walachia, Servia, Bvlgaria, Romania",
    subtitle: "Peninsula Balcanică și Țara Românească - Gerardus Mercator 1595",
    audioUrl: "/audio/walachia-servia-bulgaria-romania-mercator.mp3",
    duration: "4:00",
    episode: 24,
    date: "Aprilie 2026",
    image: "/maps/walachia-servia-bulgaria-romania-mercator.jpg"
  },
  {
    id: 25,
    title: "Transylvania - Hartă Mercator",
    subtitle: "Analiza Cartografică și Antropologică a Transilvaniei",
    audioUrl: "/assets/audio/Transylvania - Hartă Mercator.mp3",
    duration: "5:00",
    episode: 25,
    date: "Februarie 2026",
    image: "/maps/Z8W_9191_thumb.jpg"
  },
  {
    id: 26,
    title: "TRANSYLVANIA",
    subtitle: "Atlas Minor - Epoca de Aur a Cartografiei",
    audioUrl: "/assets/audio/TRANSYLVANIA.mp3",
    duration: "5:00",
    episode: 26,
    date: "Februarie 2026",
    image: "/maps/NZ8_8880_thumb.jpg"
  },
  {
    id: 27,
    title: "Nova Tabula Transylvaniae",
    subtitle: "Principatul în Secolul al XVII-lea",
    audioUrl: "/audio/transylvania-sibenburgen.mp3",
    duration: "5:00",
    episode: 27,
    date: "Februarie 2026",
    image: "/maps/NZ8_8950_thumb.jpg"
  },
  {
    id: 28,
    title: "Moldavie, Appelée par d'autres Valaquie",
    subtitle: "Moldova, numită de alții Valahia - Nicolas Sanson",
    audioUrl: "/audio/Moldavie, Appelée par d'autres Valaquie.mp3",
    duration: "6:02",
    episode: 28,
    date: "Februarie 2026",
    image: "/maps/NZ8_8943_thumb.jpg"
  },
  {
    id: 29,
    title: "Exactissima Tabula qua tam Danubii Fluvii",
    subtitle: "vs Cadrilaterul Romaniei",
    audioUrl: "/audio/EXACTISSIMA TABULA QUA TAM DANUBII FLUVII PARS INFERIOR SI CADRILATERUL ROMANIEI.mp3",
    duration: "5:47",
    episode: 29,
    date: "Februarie 2026",
    image: "/maps/NZ8_8930_thumb.jpg"
  },
  {
    id: 30,
    title: "Principatus Valachiae, Moldaviae et Transylvaniae",
    subtitle: "Orizonturi Românești - Valk",
    audioUrl: "/audio/principatus-valachiae.mp3",
    duration: "5:12",
    episode: 30,
    date: "Februarie 2026",
    image: "/maps/NZ8_8936_thumb.jpg"
  },
  {
    id: 31,
    title: "Danubii Fluminis Pars Infima",
    subtitle: "Dunărea Inferioară: Valahia, Moldova, Bulgaria, Basarabia - Johann Baptist Homann, 1716, Nürnberg",
    audioUrl: "/audio/Danubii Fluminis Pars Infima.mp3",
    duration: "5:00",
    episode: 31,
    date: "Februarie 2026",
    image: "/maps/NZ8_8939.jpg"
  },
  {
    id: 32,
    title: "Transylvaniae, Moldaviae, Walachiae, Bulgariae",
    subtitle: "Transilvania, Moldova, Valahia și Bulgaria — Johann Georg Schreiber, 1730",
    audioUrl: "/audio/Transylvaniae, Moldaviae, Walachiae, Bulgariae - Schreiber 1730.mp3",
    duration: "21:18",
    episode: 32,
    date: "Septembrie 2026",
    image: "/maps/Z8L_3042.jpg"
  },
  {
    id: 33,
    title: "Fluviorum in Europa Principis DANUBII",
    subtitle: "Novissima Tabula - Johann Baptist Homann, 1730, Nürnberg",
    audioUrl: "/audio/Fluviorum in Europa primum DANUBII.mp3",
    duration: "5:00",
    episode: 33,
    date: "Februarie 2026",
    image: "/maps/Z8L_5002_thumb.jpg"
  },
  {
    id: 34,
    title: "TRANSYLVANIA, MOLDAVIA, WALACHIA, BULGARIA",
    subtitle: "Magnam partem hodierni Theatri Bellici — Matthäus Seutter, 1735-1750",
    audioUrl: "/audio/Transylvaniae, Moldaviae, Walachiae, Bulgariae nova et accurata Delineatio.mp3",
    duration: "6:32",
    episode: 34,
    date: "Februarie 2026",
    image: "/maps/Z8L_5001_thumb.jpg"
  },
  {
    id: 35,
    title: "Carte der Wallachei",
    subtitle: "Harta Țării Românești la sfârșitul sec. XVIII",
    audioUrl: "/audio/Carte der Wallachei.mp3",
    duration: "6:44",
    episode: 35,
    date: "Februarie 2026",
    image: "/maps/Z8W_9212_thumb.jpg"
  },
  {
    id: 36,
    title: "Principati di Moldavia e Vallachia",
    subtitle: "Principatele Moldovei și Valahiei - Giovanni Maria Cassini",
    audioUrl: "/audio/Principati di Moldavia e Vallachia.mp3",
    duration: "5:00",
    episode: 36,
    date: "Februarie 2026",
    image: "/maps/Z8W_9205.jpg"
  },
  {
    id: 37,
    title: "Banatul de Sud-Vest (1788)",
    subtitle: "Kriegscharte - Joseph Von Reilly",
    audioUrl: "/audio/Batalia din Banat.mp3",
    duration: "6:04",
    episode: 37,
    date: "Februarie 2026",
    image: "/maps/NZ8_8894.jpg"
  },
  {
    id: 38,
    title: "Das Fürstenthum Walachey Nro. 13",
    subtitle: "Teatrul celor cinci părți ale lumii - Reilly",
    audioUrl: "/audio/Das Fürstenthum Walachey Nro. 13.mp3",
    duration: "5:00",
    episode: 38,
    date: "Februarie 2026",
    image: "/maps/NZ8_8901.jpg"
  },
  {
    id: 39,
    title: "Des Furstenthums Moldau Noerdliche Helfte",
    subtitle: "Partea de Nord a Principatului Moldovei",
    audioUrl: "/audio/Des Furstenthums Moldau Noerdliche Haelfte.mp3",
    duration: "4:52",
    episode: 39,
    date: "Februarie 2026",
    image: "/maps/NZ8_8862.jpg"
  },
  {
    id: 40,
    title: "Des Furstenthums Moldau Sudliche Helfte Nro 10",
    subtitle: "Jumătatea Sudică a Principatului Moldovei",
    audioUrl: "/audio/Des Furstenthums Moldau Sudliche Helfte Nro 10.mp3",
    duration: "5:00",
    episode: 40,
    date: "Februarie 2026",
    image: "/maps/NZ8_8889.jpg"
  },
  {
    id: 41,
    title: "Harta României Mari, Regatul României",
    subtitle: "Cele 71 de județe interbelice — M.D. Moldoveanu, 1926",
    audioUrl: "/audio/Harta Romaniei Mari - Moldoveanu 1926.mp3",
    duration: "4:18",
    episode: 41,
    date: "Noiembrie 2026",
    image: "/maps/MOLDOVEANU_ROMANIA_MARE_1926_thumb.jpg"
  },

  // ===== IMPERIUL OTOMAN =====
  {
    id: 42,
    title: "Constantinopel — Vedere Panoramică din Cosmographia",
    subtitle: "Întemeierea Noii Rome - Sebastian Münster, Basel",
    audioUrl: "/audio/Constantinopel - Cosmographia Munster.mp3",
    duration: "20:50",
    episode: 42,
    date: "August 2026",
    image: "/maps/MUNSTER_CONSTANTINOPEL_1550.jpg"
  },
  {
    id: 43,
    title: "Turcici Imperii Descriptio",
    subtitle: "Theatrum Orbis Terrarum - Ortelius (1570)",
    audioUrl: "/audio/turcici-imperii-descriptio.mp3",
    duration: "6:00",
    episode: 43,
    date: "Februarie 2026",
    image: "/maps/NZ8_8921.jpg"
  },
  {
    id: 44,
    title: "Turcicum Imperium",
    subtitle: "Imperiul Otoman - Frederick de Wit 1680, Amsterdam",
    audioUrl: "/audio/turcicum-imperium-dewit-1680.mp3",
    duration: "3:00",
    episode: 44,
    date: "Aprilie 2026",
    image: "/maps/turcicum-imperium-dewit-1680.jpeg"
  },
  {
    id: 45,
    title: "LE BOSPHORE DE THRACE",
    subtitle: "Bosforul Traciei - Aujourduy le Detroit de Constantinople",
    audioUrl: "/audio/LE BOSPHORE DE THRACE.mp3",
    duration: "5:00",
    episode: 45,
    date: "Februarie 2026",
    image: "/maps/Z8L_5049.jpg"
  },
  {
    id: 46,
    title: "IMPERIUM TURCICUM in EUROPA ASIA et AFRICA",
    subtitle: "Regiones Propriae, Tributariae, Clientelares",
    audioUrl: "/audio/IMPERIUM TURCICUM in EUROPA ASIA et AFRICA.mp3",
    duration: "5:00",
    episode: 46,
    date: "Februarie 2026",
    image: "/maps/Z8L_5008_thumb.jpg"
  },
  {
    id: 47,
    title: "TURKEY IN EUROPE",
    subtitle: "Turcia în Europa - Herman Moll",
    audioUrl: "/audio/TURKEY IN EUROPE.mp3",
    duration: "5:00",
    episode: 47,
    date: "Februarie 2026",
    image: "/maps/Z8L_5017_thumb.jpg"
  },
  {
    id: 48,
    title: "Nova Imperii Turcarum Tabula",
    subtitle: "Epoca Fanariotă și a Lalelei (cca. 1730)",
    audioUrl: "/audio/nova-imperii-turcarum.mp3",
    duration: "7:05",
    episode: 48,
    date: "Februarie 2026",
    image: "/maps/NZ8_8915.jpg"
  },
  {
    id: 49,
    title: "DIE LANDSCHAFT ROMANIEN",
    subtitle: "Peisajul Rumeliei/Romaniei Nr. 16",
    audioUrl: "/audio/DIE LANDSCHAFT ROMANIEN.mp3",
    duration: "5:00",
    episode: 49,
    date: "Februarie 2026",
    image: "/maps/Z8L_5056.jpg"
  },
  {
    id: 50,
    title: "CARTE DE L'EMPIRE OTTOMAN EN EUROPE",
    subtitle: "Harta Imperiului Otoman în Europa",
    audioUrl: "/audio/CARTE DE L'EMPIRE OTTOMAN EN EUROPE.mp3",
    duration: "5:00",
    episode: 50,
    date: "Februarie 2026",
    image: "/maps/Z8L_5011_thumb.jpg"
  },
  {
    id: 51,
    title: "DES KOENIGREICHS BULGARIEN Westliche Hælfte",
    subtitle: "Jumătatea de Vest a Regatului Bulgariei Nr. 15",
    audioUrl: "/audio/DES KOENIGREICHS BULGARIEN Westliche Hælfte.mp3",
    duration: "5:00",
    episode: 51,
    date: "Februarie 2026",
    image: "/maps/Z8L_5054.jpg"
  },
  {
    id: 52,
    title: "Karte von dem Oschmanischen Reiche",
    subtitle: "Imperiul Otoman în Europa (cca. 1796)",
    audioUrl: "/audio/Karte von dem Oschmanischen Reiche in Europa.mp3",
    duration: "6:10",
    episode: 52,
    date: "Februarie 2026",
    image: "/maps/Z8W_9220_thumb.jpg"
  },
  {
    id: 53,
    title: "TURQUIE D'EUROPE",
    subtitle: "Turcia Europeană - A.H. Dufour",
    audioUrl: "/audio/TURQUIE D'EUROPE.mp3",
    duration: "5:00",
    episode: 53,
    date: "Februarie 2026",
    image: "/maps/Z8L_5015_thumb.jpg"
  },
  {
    id: 54,
    title: "TURKEY IN EUROPE & THE BALKANS",
    subtitle: "Turcia Europeană și Balcanii",
    audioUrl: "/audio/TURKEY IN EUROPE & THE BALKANS.mp3",
    duration: "5:00",
    episode: 54,
    date: "Februarie 2026",
    image: "/maps/Z8L_5064_thumb.jpg"
  },

  // ===== EUROPA =====
  {
    id: 55,
    title: "Hungariae Descriptio",
    subtitle: "Wolfgang Lazius / Ortelius",
    audioUrl: "/audio/hungariae-descriptio.mp3",
    duration: "5:15",
    episode: 55,
    date: "Februarie 2026",
    image: "/maps/NZ8_8945_thumb.jpg"
  },
  {
    id: 56,
    title: "Romaniae, (quae olim Thracia dicta) Vicinarumque Regionum Descriptio",
    subtitle: "Spațiul Balcanic și Românesc - Ortelius / Gastaldi 1588",
    audioUrl: "/audio/ORTELIUS Romaniae, (quae olim Thracia dicta) Vicinarumque Regionum, Uti Bulgariae, Walachiae, Syrfiae AUDIO.mp3",
    duration: "5:00",
    episode: 56,
    date: "Aprilie 2026",
    image: "/maps/romaniae-quae-olim-thracia.jpg"
  },
  {
    id: 57,
    title: "Taurica Chersonesus Nostra aetate Przecopsca et Gazara dicitur",
    subtitle: "Hanatul Crimeei și Stepa Pontică în Cartografia Mercatoriană - Gerardus / Rumold Mercator, 1595",
    audioUrl: "/audio/Taurica Chersonesus.mp3",
    duration: "5:00",
    episode: 57,
    date: "Iunie 2026",
    image: "/maps/MERCATOR_TAURICA_1595.jpg"
  },
  {
    id: 58,
    title: "Danubius, Fluvius Europae Maximus",
    subtitle: "Dunărea de la izvoare la vărsare — Willem Janszoon Blaeu, Amsterdam, 1635",
    audioUrl: "/audio/Danubius Fluvius Europae Maximus - Blaeu.mp3",
    duration: "5:57",
    episode: 58,
    date: "Noiembrie 2026",
    image: "/maps/BLAEU_DANUBIUS_1635_thumb.jpg"
  },
  {
    id: 59,
    title: "Totius Regni Hungariae",
    subtitle: "Harta Întregului Regat al Ungariei",
    audioUrl: "/audio/Totius Regni Hungariae et adjacentium Regionum Tabula.mp3",
    duration: "5:13",
    episode: 59,
    date: "Februarie 2026",
    image: "/maps/Z8W_9215_thumb.jpg"
  },
  {
    id: 60,
    title: "L'EUROPE 1700",
    subtitle: "O Analiză Monografică a Cartografiei - Guillaume Delisle",
    audioUrl: "/audio/L'EUROPE 1700.mp3",
    duration: "5:00",
    episode: 60,
    date: "Februarie 2026",
    image: "/maps/NZ8_8911_thumb.jpg"
  },
  {
    id: 61,
    title: "Fluminum Princeps Danubius",
    subtitle: "Prințul Fluviilor: Dunărea - Gerard Valk cca. 1700",
    audioUrl: "/audio/Fluminum Princeps Danubius AUDIO.mp3",
    duration: "5:00",
    episode: 61,
    date: "Aprilie 2026",
    image: "/maps/fluminum-princeps-danubius.jpg"
  },
  {
    id: 62,
    title: "TABULA GEOGRAPHICA RUSSIA MAGNA",
    subtitle: "Rusia Mare, Pontus Euxinus și Tartaria Mică",
    audioUrl: "/audio/abula Geographica qua pars Russiae Magnae Pontus Euxinus seu Mare Nigrum et Tartaria Minor.mp3",
    duration: "5:00",
    episode: 62,
    date: "Februarie 2026",
    image: "/maps/Z8L_5172_thumb.jpg"
  },
  {
    id: 63,
    title: "La Hongrie Suivant les Nouvelles Observations",
    subtitle: "O Analiză Cartografică și Istorică Exhaustivă",
    audioUrl: "/audio/La Hongrie Suivant les Nouvelles Observations.mp3",
    duration: "5:00",
    episode: 63,
    date: "Februarie 2026",
    image: "/maps/NZ8_8865_thumb.jpg"
  },
  {
    id: 64,
    title: "Scena Historiarum Orientalis Quinti Seculi",
    subtitle: "Geopolitica Antichității Târzii - Christoph Weigel 1718",
    audioUrl: "/audio/CH. WEIGEL Scena Historiarum Orientalis Quinti AUDIO.mp3",
    duration: "5:00",
    episode: 64,
    date: "Aprilie 2026",
    image: "/maps/scena-historiarum-orientalis.jpg"
  },
  {
    id: 65,
    title: "Danubius & Ister cum Dominio Turcico in Europa",
    subtitle: "Dunărea de la Izvor la Vărsare - Christoph Weigel 1720",
    audioUrl: "/audio/Danubius & Ister cum Dominio Turcico in Europa et adjacentibus Regionibus descriptus a fonte ad Ostia AUDIO.mp3",
    duration: "5:00",
    episode: 65,
    date: "Aprilie 2026",
    image: "/maps/danubius-ister-dominio-turcico.jpg"
  },
  {
    id: 66,
    title: "Nova et Accurata Regni Hungariae Tabula",
    subtitle: "Regatul Ungariei, Transilvania, Valahia și Moldova după ridicările contelui Marsigli - Guillaume Delisle",
    audioUrl: "/audio/Regni Hungariae Tabula - Delisle.mp3",
    duration: "16:43",
    episode: 66,
    date: "August 2026",
    image: "/maps/DELISLE_HUNGARIAE_1742.jpg"
  },
  {
    id: 67,
    title: "Le Royaume de Hongrie",
    subtitle: "Regatul Ungariei și țările care depindeau de acesta",
    audioUrl: "/audio/Le Royaume de Hongrie et des pays qui en dependoient autrefois.mp3",
    duration: "6:29",
    episode: 67,
    date: "Februarie 2026",
    image: "/maps/Z8W_9201_thumb.jpg"
  },
  {
    id: 68,
    title: "Hungariae ampliori significatu",
    subtitle: "Harta metodică a Regatului Ungariei - Hase 1744",
    audioUrl: "/audio/Hungariae ampliori significatu et veteris vel Methodicae complexae Regna.mp3",
    duration: "5:29",
    episode: 68,
    date: "Februarie 2026",
    image: "/maps/Z8W_9203_thumb.jpg"
  },
  {
    id: 69,
    title: "Graeciae Pars Septentrionalis",
    subtitle: "Grecia Septentrională — Matthäus Seutter, Augsburg c. 1745",
    audioUrl: "/audio/seutter-graecia-1745.mp3",
    duration: "17:54",
    episode: 69,
    date: "Mai 2026",
    image: "/maps/117753.jpg"
  },
  {
    id: 70,
    title: "Nova Mappa Maris Nigri",
    subtitle: "Harta Mării Negre - Seutter & Lotter",
    audioUrl: "/audio/nova-mapa-maris-nigri.mp3",
    duration: "5:48",
    episode: 70,
    date: "Februarie 2026",
    image: "/maps/NZ8_8918_thumb.jpg"
  },
  {
    id: 71,
    title: "Le Royaume de Hongrie",
    subtitle: "Cartografia Tranziției Imperiale - Janvier",
    audioUrl: "/audio/Le Royaume de Hongrie.mp3",
    duration: "5:00",
    episode: 71,
    date: "Februarie 2026",
    image: "/maps/NZ8_8956_thumb.jpg"
  },
  {
    id: 72,
    title: "CARTE DU PALUS MÉOTIDE ET DU PONT EUXIN",
    subtitle: "Harta Mlaștinii Meotide și a Mării Euxinului",
    audioUrl: "/audio/CARTE DU PALUS MÉOTIDE ET DU PONT EUXIN.mp3",
    duration: "5:00",
    episode: 72,
    date: "Februarie 2026",
    image: "/maps/Z8L_5025_color.jpg"
  },
  {
    id: 73,
    title: "L'EUROPE divisée EN SES PRINCIPAUX ÉTATS",
    subtitle: "Europa împărțită în statele sale principale",
    audioUrl: "/audio/L'EUROPE divisée EN SES PRINCIPAUX ÉTATS.mp3",
    duration: "5:00",
    episode: 73,
    date: "Februarie 2026",
    image: "/maps/Z8L_5023_thumb.jpg"
  },
  {
    id: 74,
    title: "CARTE DU BASSIN DE LA MER MÉDITERRANÉE",
    subtitle: "Harta Bazinului Mării Mediterane",
    audioUrl: "/audio/CARTE DU BASSIN DE LA MER MÉDITERRANÉE.mp3",
    duration: "5:52",
    episode: 74,
    date: "Februarie 2026",
    image: "/maps/Z8L_5090_thumb.jpg"
  },
  {
    id: 75,
    title: "CARTE GÉNÉRALE DE L'EUROPE ACTUELLE",
    subtitle: "Harta Generală a Europei Actuale - 1860",
    audioUrl: "/audio/CARTE GÉNÉRALE DE L'EUROPE ACTUELLE.mp3",
    duration: "5:00",
    episode: 75,
    date: "Februarie 2026",
    image: "/maps/Z8L_5012_thumb.jpg"
  },
  {
    id: 76,
    title: "Der russisch-türkische KRIEGSSCHAUPLATZ",
    subtitle: "Teatrul de Război Ruso-Turc (1877-1878)",
    audioUrl: "/audio/Der russisch-türkische KRIEGSSCHAUPLATZ.mp3",
    duration: "4:51",
    episode: 76,
    date: "Februarie 2026",
    image: "/maps/Z8W_9213_thumb.jpg"
  },
  {
    id: 77,
    title: "Karte der Balkanhalbinsel",
    subtitle: "Harta Peninsulei Balcanice - San Stefano (1878)",
    audioUrl: "/audio/Karte der Balkanhalbinsel nach den Friedensbestimmungen von San Stefano.mp3",
    duration: "6:07",
    episode: 77,
    date: "Februarie 2026",
    image: "/maps/Z8W_9206_thumb.jpg"
  },
  {
    id: 78,
    title: "Die Balkan-Halbinsel - Stieler's Handatlas",
    subtitle: "Peninsula Balcanică - Justus Perthes",
    audioUrl: "/audio/Die Balkan-Halbinsel - Stieler's Handatlas.mp3",
    duration: "5:00",
    episode: 78,
    date: "Februarie 2026",
    image: "/maps/Z8L_5067_thumb.jpg"
  },
  {
    id: 79,
    title: "BALKAN STATES & ASIA MINOR: INDUSTRIES & COMMUNICATIONS",
    subtitle: "State Balcanice și Asia Mică - Industrii și Comunicații",
    audioUrl: "/audio/BALKAN STATES & ASIA MINOR INDUSTRIES & COMMUNICATIONS.mp3",
    duration: "5:00",
    episode: 79,
    date: "Februarie 2026",
    image: "/maps/Z8L_5069_thumb.jpg"
  },
  {
    id: 80,
    title: "EUROPE: GENERAL MAP",
    subtitle: "Europa - Hartă Generală",
    audioUrl: "/audio/EUROPE GENERAL MAP.mp3",
    duration: "5:53",
    episode: 80,
    date: "Februarie 2026",
    image: "/maps/Z8L_5075_thumb.jpg"
  },
  {
    id: 81,
    title: "SCENA HISTORIARUM OCCIDENTALIS",
    subtitle: "Scena Istoriilor Occidentale din Secolul al V-lea",
    audioUrl: "/audio/Scena Historiarum Occidentalis Quinti Seculi P. N. Chr.mp3",
    duration: "5:54",
    episode: 81,
    date: "Februarie 2026",
    image: "/maps/Z8L_5084_thumb.jpg"
  },

  // ===== LUMEA ANTICA =====
  {
    id: 82,
    title: "MONDE CONNU DES ANCIENS",
    subtitle: "Lumea Cunoscută a Anticilor",
    audioUrl: "/audio/MONDE CONNU DES ANCIENS.mp3",
    duration: "5:29",
    episode: 82,
    date: "Februarie 2026",
    image: "/maps/Z8L_5041_thumb.jpg"
  },
  {
    id: 83,
    title: "Tabula Topographica Athenarum Veterum et Novarum",
    subtitle: "Atena Antică și Modernă - Coronelli / Weigel 1720",
    audioUrl: "/audio/Tabula Topographica Athenarum Veterum et Novarum.mp3",
    duration: "5:00",
    episode: 83,
    date: "Aprilie 2026",
    image: "/maps/tabula-topographica-athenarum.jpg"
  },
  {
    id: 84,
    title: "Alexandri Magni imperium et expeditio",
    subtitle: "Imperiul lui Alexandru cel Mare — Guillaume de L'Isle / Buache, 1731",
    audioUrl: "/audio/delisle-alexandri-1731.mp3",
    duration: "19:55",
    episode: 84,
    date: "Mai 2026",
    image: "/maps/DELISLE_ALEXANDRI_1731.jpg"
  },
  {
    id: 85,
    title: "Orbis Herodoti",
    subtitle: "Lumea lui Herodot",
    audioUrl: "/audio/Orbis Herodoti.mp3",
    duration: "6:15",
    episode: 85,
    date: "Februarie 2026",
    image: "/maps/NZ8_8867_thumb.jpg"
  },
  {
    id: 86,
    title: "2 MONDE CONNU DES ANCIENS",
    subtitle: "Lumea Cunoscută de Antici - Herodot și Ptolemeu",
    audioUrl: "/audio/2 MONDE CONNU DES ANCIENS.mp3",
    duration: "5:00",
    episode: 86,
    date: "Februarie 2026",
    image: "/maps/Z8L_5086_thumb.jpg"
  },
  {
    id: 87,
    title: "EMPIRE ROMAIN",
    subtitle: "Imperiul Roman la Apogeul Său",
    audioUrl: "/audio/Carte de l'Empire Romain.mp3",
    duration: "6:09",
    episode: 87,
    date: "Februarie 2026",
    image: "/maps/Z8L_5088_thumb.jpg"
  },

  // ===== ASIA =====
  {
    id: 88,
    title: "ASIAE NOVA DESCRIPTIO",
    subtitle: "Noua Descriere a Asiei",
    audioUrl: "/audio/Asiae Nova Descriptio.mp3",
    duration: "6:49",
    episode: 88,
    date: "Februarie 2026",
    image: "/maps/Z8L_5174_thumb.jpg"
  },
  {
    id: 89,
    title: "Natoliae Quae Olim Asia Minor / Aegypti Recentior / Carthaginis Celeberrimi Sinus Typus",
    subtitle: "Planșă triplu-cartografică din Atlasul Cosmographicae al lui Mercator, 1595",
    audioUrl: "/audio/Natoliae Quae Olim Asia Minor Aegypti Carthaginis.mp3",
    duration: "5:00",
    episode: 89,
    date: "Iunie 2026",
    image: "/maps/MERCATOR_NATOLIA_AEGYPTI_1595.jpg"
  },
  {
    id: 90,
    title: "Geographische Beschryvinghe van de Wandeling der Apostelen",
    subtitle: "Călătoriile Apostolilor — Nicolaes Visscher I, Amsterdam c. 1660",
    audioUrl: "/audio/visscher-apostelen-1660.mp3",
    duration: "17:47",
    episode: 90,
    date: "Mai 2026",
    image: "/maps/114027.jpg"
  },
  {
    id: 91,
    title: "A New Map of the Western Parts of Asia Minor",
    subtitle: "Asia Mică Antică — Edward Wells, Oxford 1704",
    audioUrl: "/audio/wells-asia-minor-1704.mp3",
    duration: "15:52",
    episode: 91,
    date: "Mai 2026",
    image: "/maps/WELLS_ASIA_MINOR_1704.jpg"
  },
];

const AudioContext = createContext(null);

export const useAudio = () => {
  const context = useContext(AudioContext);
  if (!context) {
    throw new Error('useAudio must be used within an AudioProvider');
  }
  return context;
};

export const AudioProvider = ({ children }) => {
  const audioRef = useRef(new Audio());
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentAudio, setCurrentAudio] = useState(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [showMiniPlayer, setShowMiniPlayer] = useState(false);
  const [playbackRate, setPlaybackRate] = useState(1);
  const isLoadingRef = useRef(false);
  const playPromiseRef = useRef(null);

  useEffect(() => {
    const audio = audioRef.current;
    
    const handleTimeUpdate = () => {
      setCurrentTime(audio.currentTime);
    };
    
    const handleLoadedMetadata = () => {
      setDuration(audio.duration);
    };
    
    const handleEnded = () => {
      if (currentAudio) {
        const currentIndex = audioData.findIndex(a => a.id === currentAudio.id);
        if (currentIndex < audioData.length - 1) {
          playAudio(audioData[currentIndex + 1]);
        } else {
          setIsPlaying(false);
        }
      }
    };

    audio.addEventListener('timeupdate', handleTimeUpdate);
    audio.addEventListener('loadedmetadata', handleLoadedMetadata);
    audio.addEventListener('ended', handleEnded);

    return () => {
      audio.removeEventListener('timeupdate', handleTimeUpdate);
      audio.removeEventListener('loadedmetadata', handleLoadedMetadata);
      audio.removeEventListener('ended', handleEnded);
    };
  }, [currentAudio]);

  const playAudio = useCallback(async (audio) => {
    if (isLoadingRef.current) return;
    
    const audioElement = audioRef.current;
    
    if (playPromiseRef.current) {
      try {
        await playPromiseRef.current;
      } catch (e) {
        // Ignore interrupted play errors
      }
      playPromiseRef.current = null;
    }
    
    if (currentAudio?.id !== audio.id) {
      isLoadingRef.current = true;
      
      audioElement.pause();
      audioElement.src = audio.audioUrl;
      setCurrentAudio(audio);
      
      await new Promise((resolve) => {
        const handleCanPlay = () => {
          audioElement.removeEventListener('canplay', handleCanPlay);
          resolve();
        };
        audioElement.addEventListener('canplay', handleCanPlay);
        audioElement.load();
      });
      
      isLoadingRef.current = false;
    }
    
    try {
      playPromiseRef.current = audioElement.play();
      await playPromiseRef.current;
      setIsPlaying(true);
      setShowMiniPlayer(true);
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.warn('Audio play error:', error);
      }
    } finally {
      playPromiseRef.current = null;
    }
  }, [currentAudio]);

  const pauseAudio = useCallback(() => {
    audioRef.current.pause();
    setIsPlaying(false);
  }, []);

  const togglePlayPause = useCallback(async () => {
    if (isPlaying) {
      pauseAudio();
    } else if (currentAudio) {
      try {
        playPromiseRef.current = audioRef.current.play();
        await playPromiseRef.current;
        setIsPlaying(true);
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.warn('Toggle play error:', error);
        }
      } finally {
        playPromiseRef.current = null;
      }
    }
  }, [isPlaying, currentAudio, pauseAudio]);

  const seekTo = useCallback((time) => {
    audioRef.current.currentTime = time;
    setCurrentTime(time);
  }, []);

  const playNext = useCallback(() => {
    if (isLoadingRef.current) return;
    if (!currentAudio) return;
    const currentIndex = audioData.findIndex(a => a.id === currentAudio.id);
    if (currentIndex < audioData.length - 1) {
      playAudio(audioData[currentIndex + 1]);
    }
  }, [currentAudio, playAudio]);

  const playPrevious = useCallback(() => {
    if (isLoadingRef.current) return;
    if (!currentAudio) return;
    const currentIndex = audioData.findIndex(a => a.id === currentAudio.id);
    if (currentIndex > 0) {
      playAudio(audioData[currentIndex - 1]);
    }
  }, [currentAudio, playAudio]);

  const closeMiniPlayer = useCallback(() => {
    pauseAudio();
    setShowMiniPlayer(false);
    setCurrentAudio(null);
  }, [pauseAudio]);

  const changePlaybackRate = useCallback((rate) => {
    audioRef.current.playbackRate = rate;
    setPlaybackRate(rate);
  }, []);

  const skipBackward = useCallback((seconds = 10) => {
    const newTime = Math.max(0, audioRef.current.currentTime - seconds);
    audioRef.current.currentTime = newTime;
    setCurrentTime(newTime);
  }, []);

  const skipForward = useCallback((seconds = 30) => {
    const newTime = Math.min(audioRef.current.duration || 0, audioRef.current.currentTime + seconds);
    audioRef.current.currentTime = newTime;
    setCurrentTime(newTime);
  }, []);

  const value = {
    isPlaying,
    currentAudio,
    currentTime,
    duration,
    showMiniPlayer,
    audioData,
    playbackRate,
    playAudio,
    pauseAudio,
    togglePlayPause,
    seekTo,
    playNext,
    playPrevious,
    closeMiniPlayer,
    changePlaybackRate,
    skipBackward,
    skipForward,
  };

  return (
    <AudioContext.Provider value={value}>
      {children}
    </AudioContext.Provider>
  );
};

export default AudioContext;
